exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-balance[data-v-d8b8128e] {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin: 30px 0;\n}\n@media (max-width: 800px) {\n.filter-balance[data-v-d8b8128e] {\n    flex-direction: column;\n}\n}\n.filter-balance .btn-filter[data-v-d8b8128e] {\n  min-width: 164px;\n  min-height: 35px;\n  border: 1px solid var(--v-primary-base);\n  color: var(--v-gray-darken4);\n}\n@media (max-width: 800px) {\n.filter-balance .btn-filter[data-v-d8b8128e] {\n    min-width: 100%;\n}\n}\n", ""]);

// exports
